export class AnnuitantDoctor {
    partyType: null;
    organisationName: null;
    addressline1: string;
    addressline2: string;
    addressline3: string;
    addressline4: string;
    emailAddress: null;
    contactNumber: null;
    title: null;
    forename: null;
    middleName: null;
    surname: null;
    thirdName: null;
    postcode: string;
    annReportViewReqInd: string;
    countryCode: string;
    ukAddressIndicator: string;
 }

export class DependantDoctor {
    partyType: null;
    organisationName: null; 
    addressline1: string;
    addressline2: string;
    addressline3: string;
    addressline4: string;
    emailAddress: null;
    contactNumber: null;
    title: null;
    forename: null;
    middleName: null;
    surname: null;
    thirdName: null;
    postcode: string;
    depReportViewReqInd: string;
    countryCode: string;
    ukAddressIndicator: string;
}
